import React, { useRef } from "react";
import "./Carousel.scss";

import AluminiPicture from "../../../assets/logos/RentlyBuzzLogo.webp";
// Each card now has an icon and a label
const cards = [
  {
    icon: (
      <img
        src={AluminiPicture}
        alt="Invoices"
        style={{
          width: "3rem",
          height: "3rem",
          borderRadius: "50%",
        }}
      />
    ),
    label: "Tenant Management",
  },
  {
    icon: (
      <img
        src={AluminiPicture}
        alt="Invoices"
        style={{
          width: "3rem",
          height: "3rem",
          borderRadius: "50%",
        }}
      />
    ),
    label: "Lease Tracking",
  },
  {
    icon: (
      <img
        src={AluminiPicture}
        alt="Invoices"
        style={{
          width: "3rem",
          height: "3rem",
          borderRadius: "50%",
        }}
      />
    ),
    label: "Online Payments",
  },
  {
    icon: (
      <img
        src={AluminiPicture}
        alt="Invoices"
        style={{
          width: "3rem",
          height: "3rem",
          borderRadius: "50%",
        }}
      />
    ),
    label: "Maintenance Requests",
  },
  {
    icon: (
      <img
        src={AluminiPicture}
        alt="Invoices"
        style={{
          width: "3rem",
          height: "3rem",
          borderRadius: "50%",
        }}
      />
    ),
    label: "Expense Tracking",
  },
  {
    icon: (
      <img
        src={AluminiPicture}
        alt="Invoices"
        style={{
          width: "3rem",
          height: "3rem",
          borderRadius: "50%",
        }}
      />
    ),
    label: "Reporting & Analytics",
  },
];

// Duplicate for seamless looping
const carouselCards = [...cards, ...cards];

export default function Carousel({ direction = "left" }) {
  const testimonialCarouselRef = useRef(null);

  return (
    <div className="carousel" ref={testimonialCarouselRef}>
      <div
        className={
          direction === "right" ? "carousel-track-reverse" : "carousel-track"
        }
      >
        {carouselCards.map((card, idx) => (
          <div className="icon-label-card" key={`icon-label-${idx}`}>
            <img
              src={AluminiPicture}
              alt="Invoices"
              style={{
                width: "3rem",
                height: "3rem",
                borderRadius: "50%",
              }}
            />
            <span className="label">{card.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
